export const serviceList = [
    'projectAdmin',
    'boards',
    'repos',
    'pipelines',
    'sonarQube',
    'artifactory',
    //  'securityTools',
    'testplans',
];
export const sandboxServices = ['projectAdmin', 'boards', 'repos', 'pipelines'];
export const toolsOnboardingServices = ['sonarQube', 'repos', 'pipelines'];
export const noConfigServiceList = ['boards', 'repos', 'pipelines'];
export const basicServices = ['projectAdmin', 'boards'];
export const intermediateServices = ['projectAdmin', 'boards', 'repos'];
export const advancedServices = [
    'projectAdmin',
    'boards',
    'repos',
    'pipelines',
    'sonarQube',
    'artifactory',
    // 'securityTools',
    'testplans',
];
export const PRE_PREVIEW_ORDER = 'pre-preview-order';
